import { Decimal } from "decimal.js";
import { z } from "zod";

const attributeSchema = z.array(
  z.object({
    attributeSpecId: z.number(),
    textValue: z.string().nullish(),
    numericValue: z.instanceof(Decimal).nullish(),
    booleanValue: z.boolean().nullish(),
  }),
);

export const update = z.object({
  id: z.number(),
  resultId: z.string().optional(),
  resultNumeric: z.instanceof(Decimal).optional(),
  resultHla: z.array(z.string()).optional(),
  resultFreeText: z.string().optional(),
  status: z.enum(["initial", "final"]),
  comment: z.string().optional(),
  auditReason: z.string().min(1, "Reason is required"),
  attributes: attributeSchema.optional().prefault([]),
  sampleId: z.number().optional(),
});

export const create = z.object({
  testOrderId: z.number(),
  testResultSpecId: z.number(),
  // A result may have no sample (e.g. workflow-added results via
  // ADD_TEST_ORDER_RESULT), mirroring materialLotId / parentResultId.
  sampleId: z.number().nullable(),
  materialLotId: z.number().nullable(),
  accessionId: z.number(),
  isReflex: z.boolean().optional(),
  parentResultId: z.number().nullable(),
});

export const enumSchema = z.object({
  resultEnum: z.string(),
});

export const textSchema = z.object({
  resultId: z.string(),
});

export const numericSchema = z.object({
  resultNumeric: z.coerce.number(),
});

export const hlaSchema = z.object({
  resultHla: z.string().array().min(1),
});

export const freeTextSchema = z.object({
  resultFreeText: z.string(),
});

const entryBaseSchema = z.object({
  id: z.number(),
  sampleId: z.number(),
  instrumentId: z.coerce.number().optional(),
  effectiveAt: z.coerce.date().nullable().optional(),
  comment: z.string().optional(),
});

export const resultEntrySchema = entryBaseSchema
  .extend(enumSchema.partial().shape)
  .extend(numericSchema.partial().shape)
  .extend(hlaSchema.partial().shape)
  .extend(freeTextSchema.partial().shape);
